import { render, staticRenderFns } from "./P2P.vue?vue&type=template&id=3d1d95eb"
import script from "./P2P.vue?vue&type=script&lang=js"
export * from "./P2P.vue?vue&type=script&lang=js"
import style0 from "./P2P.vue?vue&type=style&index=0&id=3d1d95eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports